<template>
    <add-post
            v-bind="commentProps"
            :place-holder-text="placeHolderText"
            :handle-close-for-parent="toggleReplyPostBox"
            v-bind:show-post-box-on-load="true"
            :parent-id="parentId" :comment-count="commentCountValue" >
    </add-post>
</template>

<script>
    import AddPost from "../AddPost/AddPost";
    import { communityCommonConstant } from "../communityCommon.constant";

    export default {
        name: 'AddReply',
        data: () => ({
            communityCommonConstant,
            replyPostBoxOpen: false,
            commentProps: {
                canUploadImage: false,
                submitBtnText: communityCommonConstant.post.REPLY,
                showAllowCommentOption: false,
                showPostActivatorBox: false,
            },
        }),
        props: {
            parentId: {
                type: String,
                required: true,
            },
            toggleReplyPostBox: {
                type: Function,
                required: true,
            },
            commentCountValue: {
                type: Number,
                required: true,                
            },
        },
        components: {
            AddPost,
        },
        computed: {         
            placeHolderText() {
                const replyPlaceHolder = "Type here to reply";
                return replyPlaceHolder;
            },       
        },
    };
</script>
